import { useEffect, useRef, useState } from "react";
import { FaBars } from "react-icons/fa6";

const scrollToSection = (sectionID) => {
  const element = document.getElementById(sectionID);

  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

function HeaderVertical({ setBurgerOpen }) {
  const headerRef = useRef();

  useEffect(()=>{
    const handleOutsideClicks = (event) => {
      if(headerRef.current && !headerRef.current.contains(event.target)){
        setBurgerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClicks);

    return () => {document.addEventListener("mousedown", handleOutsideClicks);};

  }, [setBurgerOpen]);

  return (
    <div
    ref={headerRef} 
    className=" bg-slate-950/75 backdrop-blur-sm shadow-sm shadow-indigo-400 h-fit top-14 z-30 fixed left-0 w-full pt-4 pb-2">
      <div className="flex flex-col">
        <button
          className="nav-item-v"
          onClick={() => {
            window.scrollTo({ behavior: "smooth", top: 0 });
            setBurgerOpen(false);
          }}
        >
          Hello World
        </button>
        <button
          className="nav-item-v"
          onClick={() => {
            scrollToSection("About");
            setBurgerOpen(false);
          }}
        >
          About Me
        </button>
        <button
          className="nav-item-v"
          onClick={() => {
            scrollToSection("Projects");
            setBurgerOpen(false);
          }}
        >
          Projects
        </button>
        <button
          className="nav-item-v"
          onClick={() => {
            scrollToSection("Contact");
            setBurgerOpen(false);
          }}
        >
          Get In Touch
        </button>
      </div>
    </div>
  );
}

export default function Header() {
  const [burgerOpened, setBurgerOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <p className="text-fuchsia-400 self-center align-middle tracking-wider">
          renee-kh4n
        </p>
        <div className="nav-container">
          <button
            className="nav-item"
            onClick={() => window.scrollTo({ behavior: "smooth", top: 0 })}
          >
            Hello World
          </button>
          <button className="nav-item" onClick={() => scrollToSection("About")}>
            About Me
          </button>
          <button
            className="nav-item"
            onClick={() => scrollToSection("Projects")}
          >
            Projects
          </button>
          <button
            className="nav-item"
            onClick={() => scrollToSection("Contact")}
          >
            Get In Touch
          </button>
        </div>

        <FaBars
          size={25}
          className="ml-auto my-auto sm:hidden text-white hover:text-fuchsia-400"
          onClick={() => setBurgerOpen(!burgerOpened)}
        />
      </nav>

      {burgerOpened && <HeaderVertical setBurgerOpen={setBurgerOpen} />}
    </>
  );
}
